import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
} from '@wegroup/design-system';
import React from 'react';
import { DeepRequired, FieldErrorsImpl } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DateInputV4 } from 'wg-fe-ui';
import { Change } from '../../../../../../../types/Form';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import YesNoQuestion from '../../../ui/advisory-flow/components/shared-components/YesNoQuestion';

interface Values {
  [k: string]: unknown;
}

interface Props {
  setIsModalOpen: (arg0: boolean) => void;
  values: Values;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: FieldErrorsImpl<DeepRequired<any>>;
  setFieldValue: (
    arg0: string,
    arg1: unknown,
    options?: Record<string, boolean>,
  ) => void;
  showModal: boolean;
  handleModalYes: () => void;
}

const VehicleDataRegistrationModal: React.FC<
  React.PropsWithChildren<Props>
> = ({
  setIsModalOpen,
  showModal,
  setFieldValue,
  handleModalYes,
  values,
  errors = {},
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      onClose={() => setIsModalOpen(false)}
      isOpen={showModal}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <QuestionGroupAssistantQuestion
            question={t('Please fill in the required fields')}
            description={t(
              'Click continue at the bottom of this screen to save',
            )}
            noPadding
          />
          <VehicleDataContainer data-test-id="ProdFac_VehicleData_DataContainer">
            <StyledDateInputV4
              name="registration_first"
              initialValue={values?.['registration_first']}
              error={errors?.['registration_first']?.message}
              onChange={(e: Change) => {
                if (!e.value) return;
                setFieldValue('registration_first', e.value, {
                  shouldValidate: true,
                });
              }}
            >
              {t('First registration')}
            </StyledDateInputV4>
          </VehicleDataContainer>
        </ModalBody>
        <ModalFooter borderTop="1px" borderColor="gray.50">
          <StyledYesNoQuestion
            handleYes={handleModalYes}
            yesText={t('Continue')}
            handleNo={() => {
              setFieldValue('registration_first', undefined);
              setIsModalOpen(false);
            }}
            noText={t('Cancel')}
            disabledYes={!!errors?.['registration_first']}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const StyledYesNoQuestion = styled(YesNoQuestion)`
  width: 100%;
`;

const StyledDateInputV4 = styled(DateInputV4)`
  height: unset;
  > div {
    /* ErrorContainer */
    height: unset;
  }
`;

const VehicleDataContainer = styled.div`
  padding: 2.4rem 0;
  display: grid;
  gap: 1.6rem;
`;

export default VehicleDataRegistrationModal;
